import React from 'react';
import { MapPin, Route, Cloud, Car } from 'lucide-react';

/**
 * Компонент секции основных параметров маршрута
 */
const RouteParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  roadTypes,
  trafficLevels,
  weatherConditions
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Начальная точка */}
      <div>
        <label htmlFor="startPoint" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <MapPin className="w-4 h-4 mr-2 text-blue-500" />
          Начальная точка
        </label>
        <input
          type="text"
          id="startPoint"
          name="startPoint"
          value={formData.startPoint}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.startPoint ? 'input-error' : ''}`}
          placeholder="Например: Москва"
        />
        {errors.startPoint && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.startPoint}
          </p>
        )}
      </div>

      {/* Конечная точка */}
      <div>
        <label htmlFor="endPoint" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <MapPin className="w-4 h-4 mr-2 text-blue-500" />
          Конечная точка
        </label>
        <input
          type="text"
          id="endPoint"
          name="endPoint"
          value={formData.endPoint}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.endPoint ? 'input-error' : ''}`}
          placeholder="Например: Санкт-Петербург"
        />
        {errors.endPoint && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.endPoint}
          </p>
        )}
      </div>

      {/* Расстояние */}
      <div>
        <label htmlFor="distance" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Route className="w-4 h-4 mr-2 text-blue-500" />
          Расстояние (км)
        </label>
        <input
          type="text"
          id="distance"
          name="distance"
          value={formData.distance}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.distance ? 'input-error' : ''}`}
          placeholder="Расстояние в километрах"
        />
        {errors.distance && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.distance}
          </p>
        )}
      </div>

      {/* Тип дороги */}
      <div>
        <label htmlFor="roadType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Тип дороги
        </label>
        <select
          id="roadType"
          name="roadType"
          value={formData.roadType}
          onChange={handleInputChange}
          className="form-select w-full"
        >
          {roadTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
      </div>

      {/* Пробки */}
      <div>
        <label htmlFor="trafficJams" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Car className="w-4 h-4 mr-2 text-blue-500" />
          Дорожная обстановка
        </label>
        <select
          id="trafficJams"
          name="trafficJams"
          value={formData.trafficJams}
          onChange={handleInputChange}
          className="form-select w-full"
        >
          {trafficLevels.map((level) => (
            <option key={level.id} value={level.id}>
              {level.name}
            </option>
          ))}
        </select>
      </div>

      {/* Погодные условия */}
      <div>
        <label htmlFor="weatherCondition" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Cloud className="w-4 h-4 mr-2 text-blue-500" />
          Погодные условия
        </label>
        <select
          id="weatherCondition"
          name="weatherCondition"
          value={formData.weatherCondition}
          onChange={handleInputChange}
          className="form-select w-full"
        >
          {weatherConditions.map((condition) => (
            <option key={condition.id} value={condition.id}>
              {condition.name}
            </option>
          ))}
        </select>
      </div>

      {/* Дата отправления */}
      <div>
        <label htmlFor="departureDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Дата отправления
        </label>
        <input
          type="date"
          id="departureDate"
          name="departureDate"
          value={formData.departureDate}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.departureDate ? 'input-error' : ''}`}
        />
        {errors.departureDate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.departureDate}
          </p>
        )}
      </div>

      {/* Время отправления */}
      <div>
        <label htmlFor="departureTime" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Время отправления
        </label>
        <input
          type="time"
          id="departureTime"
          name="departureTime"
          value={formData.departureTime}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.departureTime ? 'input-error' : ''}`}
        />
        {errors.departureTime && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.departureTime}
          </p>
        )}
      </div>
    </div>
  );
};

export default RouteParametersSection;